import React, { useState } from "react";

import TopicContext from "../../../contexts/TopicContext";
import TeamTopicContext from "../../../contexts/TeamTopicContext";

import ChooseTopic from "./ChooseTopic";
import Topics from "./Topics";

export default function Index({ team }) {
  return (
    <TeamTopicContext team={team}>
      <TopicContext>
        <div className="ibox-content">
          <ChooseTopic />
          <div className="mt40">
            <Topics />
          </div>
        </div>
      </TopicContext>
    </TeamTopicContext>
  );
}
